import { fromUnixTime, getHours, getMinutes } from 'date-fns';

export const SLOT_MINUTES = {
  FIFTEEN: 15,
  THIRTY: 30,
  SIXTY: 60,
};

export const buildTimeSlots = (slotMinutes) => {
  const count = (24 * 60) / slotMinutes;
  return Array.from({ length: count }, (_, i) => {
    const startMinute = i * slotMinutes;
    const hour = Math.floor(startMinute / 60);
    const minute = startMinute % 60;
    return {
      index: i,
      startMinute,
      label: `${hour}:${String(minute).padStart(2, '0')}`,
    };
  });
};

export const aggregateEvents = (events, slotMinutes) => {
  const slotCount = (24 * 60) / slotMinutes;
  const slots = Array.from({ length: slotCount }, () => []);

  events.forEach((event) => {
    const time = fromUnixTime(event.timestamp);
    const minuteOfDay = getHours(time) * 60 + getMinutes(time);
    const index = Math.floor(minuteOfDay / slotMinutes);

    if (index >= 0 && index < slotCount) {
      slots[index].push(event);
    }
  });

  return slots;
};

export const getIntensityLevel = (count, maxCount) => {
  if (count === 0 || maxCount === 0) return 0;
  const ratio = count / maxCount;
  if (ratio <= 0.25) return 1;
  if (ratio <= 0.5) return 2;
  if (ratio <= 0.75) return 3;
  return 4;
};
